import type { ScheduleLayoutType } from './ScheduleLayoutSelector.types';

export type ScheduleTimelineVariant = ScheduleLayoutType | null;

const isScheduleLayoutType = (v: string | null | undefined): v is ScheduleLayoutType => v === 'classic' || v === 'timeline' || v === 'cards' || v === 'compact' || v === 'centered';

export const getScheduleVariant = (layoutType: string | null | undefined): ScheduleTimelineVariant => (isScheduleLayoutType(layoutType) ? layoutType : null);

// Source of truth for the admin selector default AND the guest-site renderer —
// keep both call-sites pointed at this function so they cannot drift.
export const getEffectiveScheduleLayout = (layoutType: string | null | undefined, isRedesignEnabled: boolean): ScheduleLayoutType => {
  const variant = getScheduleVariant(layoutType);
  if (variant !== null) return variant;
  return isRedesignEnabled ? 'classic' : 'centered';
};
